import { createTheme } from "@mui/material/styles";

type Mode = "light" | "dark";

export function makeTheme(mode: Mode) {
    return createTheme({
        palette: {
            mode,
        },
        shape: { borderRadius: 14 },
        typography: {
            fontFamily:
                'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
        },
        components: {
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundImage: "none",
                    },
                },
            },
            MuiButton: {
                defaultProps: { disableElevation: true },
                styleOverrides: {
                    root: { borderRadius: 14, fontWeight: 900 },
                },
            },
        },
    });
}
